module.exports = function(service) {
	'use strict'
	service.factory('getConfigData',getConfigData);
	getConfigData.$inject=['getDataService','serverError','alertService','config','refreshtokenService','$timeout','$state','authtokenService','$rootScope','offlineError'];
	function getConfigData(getDataService,serverError,alertService,config, refreshtokenService,$timeout,$state,authtokenService,$rootScope,offlineError) {
        return {
            getData: function(type){
                return getDataService.get({param1:'config'}).$promise.then(function(data){
                    config.setConfig(data, type);
                }, function(error){
                    // Handle connection refused errors (status -1)
                    //net::ERR_CONNECTION_REFUSED → error.status = -1
                    //Server is down or not accepting connections
                    //Wrong port or firewall blocking
                    //Server overloaded and refusing connections

                    //net::ERR_INTERNET_DISCONNECTED → error.status = -1
                    //User is completely offline
                    //No internet connection available
                    //Network adapter disabled

                    if(error.status === -1) {
                        if(!window.navigator.onLine) {
                            var refresh;
                            if(type=='init') {
                                refresh = 'refresh';
                            }
                            offlineError(refresh);
                        } else {
                            if(type=='init') {
                                $rootScope.alerts = [];
                                $rootScope.alertShow = false;
                                authtokenService.removeToken();
                                $state.go('login');
                                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                            }
                        }
                        return;
                    }
                    
                    if(error.status ==401) {
                        var promise = refreshtokenService.getAccessToken();
                        promise.then(
                        function(answer) {
                            if(answer==200) {   
                                // The 'return' here ensures that the Promise chain correctly returns
                                // the retried getData call, allowing callers to use .then() as expected
                                return getConfigData.getData(type);
                            }
                        },
                        function(error) {
                        },
                        function(progress) {
                            // report progress
                        });
                    } else if(error.status ==502) {
                        serverError()
                    } else {
                        alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                    }
                })
            }
        }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/getConfigDataService.js
// module id = 604
// module chunks = 0